const BOARD_PREVIEW_STORAGE_PREFIX = 'micropinouts-board-preview:';
const BOARD_PREVIEW_MAX_AGE_MS = 6 * 60 * 60 * 1000;

const canUseLocalStorage = () => (
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
);

const getStorageKey = (token) => `${BOARD_PREVIEW_STORAGE_PREFIX}${token}`;

const safeParseJson = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

export const cleanupBoardPreviewDrafts = () => {
  if (!canUseLocalStorage()) {
    return;
  }

  const now = Date.now();
  const keysToRemove = [];

  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);

    if (!key || !key.startsWith(BOARD_PREVIEW_STORAGE_PREFIX)) {
      continue;
    }

    const payload = safeParseJson(window.localStorage.getItem(key) || '');
    const storedAt = Number(payload?.storedAt || 0);

    if (!payload || !storedAt || (now - storedAt) > BOARD_PREVIEW_MAX_AGE_MS) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};

export const createBoardPreviewDraft = (boardId, draft) => {
  if (!canUseLocalStorage() || !boardId || !draft) {
    return '';
  }

  cleanupBoardPreviewDrafts();

  const token = `${boardId}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const payload = {
    draft,
    boardId: String(boardId),
    storedAt: Date.now(),
  };

  window.localStorage.setItem(getStorageKey(token), JSON.stringify(payload));
  return token;
};

export const readBoardPreviewDraft = (token, expectedBoardId) => {
  if (!canUseLocalStorage() || !token) {
    return null;
  }

  const rawPayload = window.localStorage.getItem(getStorageKey(token));
  const payload = safeParseJson(rawPayload || '');

  if (!payload) {
    return null;
  }

  const storedAt = Number(payload.storedAt || 0);

  if (!storedAt || (Date.now() - storedAt) > BOARD_PREVIEW_MAX_AGE_MS) {
    window.localStorage.removeItem(getStorageKey(token));
    return null;
  }

  if (expectedBoardId && String(payload.boardId || '') !== String(expectedBoardId)) {
    return null;
  }

  return payload.draft || null;
};
